export default __webpack_public_path__ + "static/media/photo9.71a1e758.jpg";